import { SurfaceType } from '@jms/model';
import type { EntityManifestRoutes, ResolvedEntityOperation } from '@workbuddy/services/entities';
import { resolveEntityRecordPageUrl } from '@workbuddy/ui/v2/blocks/entity.record/entity.record.page.url';

export interface BoardPanelRecordPageInput {
  /** The panel's `openPage`; only an explicit `false` hides the control. */
  readonly openPage: boolean | undefined;
  readonly resolver: EntityManifestRoutes['record'];
  readonly slug: string | undefined;
  readonly edit: ResolvedEntityOperation | null;
  readonly id: string | null | undefined;
}

/**
 * ↗'s target, or null to hide it. A generic page is only derived for a Manage edit: a Detail editor's
 * page would be the panel again at full width, which is no page worth leaving the board for (Task).
 */
export function resolveBoardPanelRecordPageUrl(input: BoardPanelRecordPageInput): string | null {

  if (input.openPage === false || !input.id) return null;
  const derivable = input.edit?.kind === 'surface' && input.edit.surface === SurfaceType.Manage;
  return resolveEntityRecordPageUrl({ resolver: input.resolver, slug: derivable ? input.slug : undefined, operation: 'edit', id: input.id });
}

/** A new tab needs an absolute href; app-relative routes go through the base href first. */
export function boardPanelRecordPageHref(url: string, origin: string, prepareExternalUrl: (url: string) => string): string {

  return /^https?:\/\//.test(url) ? url : new URL(prepareExternalUrl(url), origin).href;
}
